<mat-card *ngIf="pbo && pos && icons | async as viewIcons">
  <mat-card-content>
    <div class="ps-grid-2-col">
      <div>
        <img class="mat-icon" [src]="viewIcons[pos.PMICON]"/>
        <span class="mat-h2">{{ pos.PMNAME }} {{ pos.PMINDEX }}</span>
      </div>
      <div style="justify-self: end">
        {{ pos.TERMIN | date }} <span *ngIf="pos.PBO_POS_LIEFERDATUM">({{ pos.PBO_POS_LIEFERDATUM | date }})</span>
        / {{ pos.BETRAG | currency }}
      </div>
    </div>

    <div class="ps-flex-container-col" style="gap: 4px; margin-top: 20px">
      <div>
        <span style="font-weight: bold">{{
            'change.pmPosition.pmDesc' | translate
          }}</span>
        {{ pos.PMDESC }}
      </div>
      <div>
        <span style="font-weight: bold">{{
            'change.pmPosition.pmSNR' | translate
          }}</span>
        {{ pos.BMNR }}
      </div>
      <div>
        <span style="font-weight: bold">{{
            'change.pmPosition.leadProject' | translate
          }}</span>
        {{ pos.PROJECTNAME }}
      </div>
      <div>
        <span style="font-weight: bold">{{
            'change.pmPosition.pmGroup' | translate
          }}</span>
        {{ pos.PMGROUP }}
      </div>
      <div><img [src]="viewIcons[pos.PMSTATUSICON]"/>{{ pos.PMSTATUS }}</div>
    </div>

    <mat-divider></mat-divider>

    <div class="ps-flex-container-col">
      <div class="ps-flex-container-row">
        <h4>{{ 'change.pmPosition.contact' | translate }}</h4>
        <div style="flex: 1 0 auto"></div>
        <button
          *ngIf="!editContacts"
          mat-icon-button
          color="primary"
          (click)="toggleEditContacts()">
          <mat-icon>edit</mat-icon>
        </button>
        <div *ngIf="editContacts">
          <button mat-button color="primary" (click)="saveContacts()">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-button color="primary" (click)="toggleEditContacts()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div>
        {{ 'change.pmPosition.planning' | translate }}:
        <span *ngIf="!editContacts">{{ pos.PM_PLANNER_NAME }}</span>
        <mat-select *ngIf="editContacts" [(ngModel)]="selectedPlanner">
          <mat-option
            *ngFor="let planner of planners$ | async"
            [value]="planner">
            {{ planner.TEXT }}
          </mat-option>
        </mat-select>
      </div>
      <div>
        {{ 'change.pmPosition.metrologist' | translate }}:
        <span *ngIf="!editContacts">{{ pos.PM_METROLOGIST_NAME }}</span>
        <mat-select *ngIf="editContacts" [(ngModel)]="selectedMetrologist">
          <mat-option
            *ngFor="let metrologist of metrologists$ | async"
            [value]="metrologist">
            {{ metrologist.TEXT }}
          </mat-option>
        </mat-select>
      </div>
      <div style="justify-self: end; align-self: end">
        <div *ngIf="pos.POS_HAS_INSPECTION_REPORT" style="color: #2E7D32">
          <mat-icon>check_circle</mat-icon>
          PRÜFBERICHT
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      mat-icon-button
      color="primary"
      matTooltip="{{ 'orders.positions.pm.documents' | translate }}"
      routerLink="/orders/{{ pbo.OBJECT_ID }}/{{ pos.LINK_ID }}/pmdocuments">
      <mat-icon>article</mat-icon>
    </button>
    <span>|</span>
    <button
      mat-button
      color="primary"
      (click)="downloadReport(pos.OBJECT_ID, 'PM-PB')">
      {{ 'change.pmPosition.testReport' | translate }}
    </button>
    <button
      mat-button
      color="primary"
      (click)="downloadReport(pos.OBJECT_ID, 'ET-TS')">
      ET
    </button>
    <button
      mat-button
      color="primary"
      (click)="downloadReport(pos.OBJECT_ID, 'ZB-TS')">
      ZB
    </button>
    <span>|</span>
    <button
      mat-button
      color="primary"
      matTooltip="Prüfbericht hochladen"
      (click)="uploadInspectionReport()">
      <mat-icon> file_upload</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
